module.exports = __webpack_public_path__ + "jab/media/ecs.005dc97b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/ecs.svg
// module id = 1475
// module chunks = 0